import { Button, Checkbox, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, Input, InputAdornment, InputLabel, makeStyles, MenuItem, OutlinedInput, Radio, RadioGroup, Select, Switch, TextField, Tooltip } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from "@material-ui/styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SlideShow from "../SlideShow";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { editProfile, getCityList, getDeliveryAreas, getDriverById, getIndividual, getIndividualDocument, getProfile, putReviewResult, editProfileAdditional, editSalaryType, getDriverAdditional } from "../../../../actions/driverAppApprovalActions";
import { addDriverInfo, editDriverAddress, updateDriverInfo } from "../../../../actions/driverActions";
import { showAlertSnackbar } from "../../../../reducers/uiSlice";
import { useToken } from "../../../../utilities/hooks";
import { getUserPreference } from "../../../../utilities/common";

const AntSwitch = withStyles((theme) => ({
    root: {
      width: 60,
      height: 24,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 3,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(34px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 20,
      height: 20,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 14,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);
const ColorButton = withStyles((theme) => ({
    root: {
        backgroundColor: 'none',
        width: '132px !important',
        borderRadius: 4,
        border: 'solid 2px #dd4b3f',
        color: '#dd4b3f',
        height: 42
    },
    disabled: {
        border: 'solid 2px #595959',
        color: '#595959 !important',
    }
}))(Button);
const ColorSelect = withStyles((theme) => ({
    root: {
        fontSize: 18,
        fontWeight: 500,
        paddingTop: 15,
        paddingBottom: 15
    }
}))(Select);
const OutlinedInputTop = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderBottom: 'none',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }
    }
}))(OutlinedInput)
const OutlinedInputBetween = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderBottom: 'none',
            borderTop: 'none',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }
}))(OutlinedInput)
const OutlinedInputBottom = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderTop: 'none',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }
}))(OutlinedInput)
const useStyles = makeStyles((theme) => ({
    titleStatus: {
        width: 152,
        padding: '5px 5px 6px 3px',
        borderRadius: 20,
        backgroundColor: '#262626',
        fontSize: 16,
        fontWeight: 'normal',
        color: '#8a8b8a',
        textAlign: 'center',
        marginLeft: 15
    },
    content: {
        paddingBottom: 45
    },
    info: {
        marginTop: 18
    },
    infoTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#8a8b8a'
    },
    infoContent: {
        paddingTop: 28,
        paddingBottom: 24,
        borderBottom: 'solid 2.5px #636463'
    },
    photoGroup: {
        position: 'absolute',
        height: 90,
        width: 120,
        border: '#e4e4e3 solid 1px',
        backgroundColor: '#262626'
    },
    switch: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 110,
        alignItems: 'center',
        marginTop: 8,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    supplies: {
        height: 46,
        marginTop: 26,
        borderRadius: 4,
        paddingTop: 16,
        paddingBottom: 12,
        border: 'solid 1.5px #e4e4e3',
        display: 'flex',
        justifyContent: 'space-evenly',
        textAlign: 'center'
    },
    supply: {
        width: 240,
        height: 38,
        borderRadius: 30,
        backgroundColor: '#e4e4e3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2
    },
    supplyMinusAdd: {
        width: 36,
        height: 36,
        backgroundColor: '#262626',
        borderRadius: 18
    },
    addtionalTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#fff',
        marginBottom: 15
    },
    buttonGroup: {
        marginTop: 29,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    dropdownStyle: {
        border: 'solid 2px #ff9d00',
        backgroundColor: '#262626'
    },
    menuItem: {
        borderTop: 'solid 2px #ff9d00',
        backgroundColor: '#262626'
    },
    formControl: {
        marginRight: 2,
        minWidth: 300,
    },
}))

function DriverRegistration(props) {
    const classes = useStyles();
    const {t} = useTranslation('driverApproval');
    const dispatch = useDispatch();
    const tokenContents = useToken();
    const userPref = getUserPreference();

    const userUS = tokenContents.userUS;
    const driverProfile = useSelector(state => state.driverAppApproval.getProfile);
    const vehicleList = useSelector(state => state.driverAppApproval.getVehicleType);
    const deliveryAreaList = useSelector(state => state.driverAppApproval.getDeliveryAreas);
    const salaryTypeList = useSelector(state => state.driver.salaryTypeList);

    const driverTypeList = [
        { label: t('full_time_driver'), value: -1 },
        { label: t('self_employee_driver'), value: 0 }
    ];
    const SELF_EMPLOYEE_DRIVER = 0;
    const DEFAULT_GROUP_CHECKED_ARR_SELF = [{id:3,checked: true}] // Self employee drivers won't default check id=1
    const DEFAULT_GROUP_CHECKED_ARR = [{id:1,checked: true},{id:3,checked: true}] // 
    const pendingReasonList = [
        {
            name: t('contact_driver_manager'),
            id: 'R0'
        },
        {
            name: t('re_upload_auto_insurance'),
            id: 'R1'
        },
        {
            name: t('re_upload_photo_id_card'),
            id: 'R2'
        }
    ];
    const DEFAULT_CLIENT = "LETIAN";
    const DEFAULT_BONUS = 0;

    const [openModal, setOpenModal] = useState(false);
    const [photoListOpen, setPhotoListOpen] = useState(false);
    const [checkedSorting, setCheckedSorting] = useState(false);
    const [supplies, setSupplies] = useState([
        {
            item: 'Working Vest(s)',
            count: 0
        },
        {
            item: 'Hat(s)',
            count: 0
        },
        {
            item: 'Car Sticker(s)',
            count: 0
        }
    ])
    const [suppliesStr, setSuppliesStr] = useState('');
    const [enableEdit, setEnableEdit] = useState(false);
    const [driverId, setDriverId] = useState();
    const [driverInfo, setDriverInfo] = useState();

    const [status, setStatus] = useState();
    const [statusLabel, setStatusLabel] = useState();
    
    const [warehouseId, setWarehouseId] = useState();
    const [lastName, setLastName] = useState();
    const [firstName, setFirstName] = useState();
    const [middleName, setMiddleName] = useState();
    const [mobile, setMobile] = useState();
    const [email, setEmail] = useState();
    const [address, setAddress] = useState();
    const [licenseNum, setLicenseNum] = useState();
    const [vehiclePlate, setVehiclePlate] = useState();
    const [expiryDate, setExpiryDate] = useState();
    const [vehicleType, setVehicleType] = useState();
    const [sin, setSin] = useState();
    const [emergencyName, setEmergencyName] = useState();
    const [emergencyNum, setEmergencyNum] = useState();
    const [accountHolder, setAccountHoler] = useState();
    const [accountNum, setAccountNum] = useState();
    const [institution,setInstitution] = useState();
    const [transit, setTransit] = useState();
    const [gst, setGst] = useState();
    const [city, setCity] = useState();
    const [zip, setZip] = useState();
    const [province, setProvince] = useState();
    const [country, setCountry] = useState();

    const [slideImages, setSlideImages] = useState([]);
    const [loading, setLoading] = useState(false);

    //the default option value when the salary type is "FIX"
    const [salaryTypeFix, setSalaryTypeFix] = useState();
    const [role, setRole] = useState(0);
    const [driverSalaryState,setDriverSalaryState] = useState([]);
    const [driverSalaryTypeFixList,setDriverSalaryTypeFixList] = useState([]);

    const [username, setUsername] = useState('');

    const [reason, setReason] = useState();

    const [backgroundChecked, setBackgroundChecked] = useState(0);

    const handleClose = () => {
        setOpenModal(false);
        props.handleClose();
    };

    function handlePhotoListClose() {
        setPhotoListOpen(false);
    }
    function handleSortingChange() {
        let checkedCopy = checkedSorting;
        setCheckedSorting(!checkedCopy);
    }
    function handleSupply(index, supply, addMinus) {
        let suppliesCopy = JSON.parse(JSON.stringify(supplies));
        let supplyCopy = JSON.parse(JSON.stringify(supply));
        if(addMinus === -1 && supplyCopy.count === 0) {
            return;
        }
        supplyCopy.count += addMinus;
        suppliesCopy[index] = supplyCopy;
        setSupplies(suppliesCopy);
    }
    function init() {
        let list = [];

        setReason('');
        setEnableEdit(false);
        setRole(0);
        setCheckedSorting(false);
        setDriverInfo({});
        setSalaryTypeFix('FIX_');   
        setBackgroundChecked(0);
    }
    function applyData(driverInfo) {
        let salaryList = [];
        let fixList = [];
        // set FIX salary type
        salaryTypeList.filter((value)=>value.indexOf("FIX_") >=0).map((item)=>{
            fixList.push({label: item, value: item});
        });        
        if (fixList && fixList.length > 0) {
            salaryList.push({label: "FIX", value: "FIX" , checked: false});
        }
        // set NON FIX salary type
        salaryTypeList.filter((value)=>value.indexOf("FIX_") < 0).map((item)=>{            
            salaryList.push({label: item, value: item, checked: false});
        });

        function compare( a, b ) {
            if ( a.value < b.value ){
              return -1;
            }
            if ( a.value > b.value ){
              return 1;
            }
            return 0;
        }
        fixList.sort(compare);
        setDriverSalaryTypeFixList(fixList);

        setRole(driverInfo.role || SELF_EMPLOYEE_DRIVER);
        setCheckedSorting(driverInfo.bossflg === 1);
        
        if (typeof(driverInfo.salary_type) !== "undefined" && driverInfo.salary_type.length > 0 && driverInfo) {   
            let salaryFixArr = driverInfo.salary_type.filter((item)=>(item.income_type).indexOf("FIX_") >=0);
            let salaryListArr = [];                      
            for (let i in salaryList)  {
                let isMatch = false;
                if (salaryList[i].value === "FIX" && (salaryFixArr!== null && salaryFixArr.length > 0)) {
                    salaryListArr.push({label: salaryList[i].value, value: salaryList[i].value, checked: true});
                    isMatch = true;
                }
                for (let j in driverInfo.salary_type) {
                    if (salaryList[i].value === driverInfo.salary_type[j].income_type) {
                        salaryListArr.push({label: salaryList[i].value, value: salaryList[i].value, checked: true});
                        isMatch = true;    
                        break;
                    }
                }
                if (!isMatch) {
                    salaryListArr.push({label: salaryList[i].value, value: salaryList[i].value, checked: false});
                }
            }
            setDriverSalaryState(salaryListArr);

            if (salaryFixArr && salaryFixArr.length > 0) {
                fixList.map((item)=>{
                    if (item.value === salaryFixArr[0]['income_type']) 
                        setSalaryTypeFix(item.value);
                });                                                    
            }
        } else {
            let salaryGroupList = [];
            fixList.splice(0,fixList.length);  
            salaryTypeList.filter((value)=>value.indexOf("FIX_") >=0).map((item)=>{            
                fixList.push({label: item, value: item});                
            });
            // set default salary type as FIX
            if (fixList.length > 0) {
                salaryGroupList.push({label: "FIX", value: "FIX" , checked: true});
                setSalaryTypeFix(fixList.sort(compare)[0].value);
            }

            salaryTypeList.filter((value)=>value.indexOf("FIX_") < 0).map((item)=>{            
                salaryGroupList.push({label: item, value: item, checked: false});
            });
            setDriverSalaryState(salaryGroupList);
        }
    }
    function handleApprove() {
        let paramsAdditional = createParamsAdditional(0);
        let salaryTypeArr = salaryTypeParam();
        if(!paramsAdditional || !salaryTypeArr) {
            return;
        }
        setLoading(true);
        editDriver(driverId);
    }
    function editDriver(accountId) {
        let paramsAdditional = createParamsAdditional();
        let salaryTypeArr = salaryTypeParam();

        if(!paramsAdditional || !salaryTypeArr) {
            return;
        }
        dispatch(editProfileAdditional(accountId, paramsAdditional))
        .then(() => {
            dispatch(editSalaryType(accountId, salaryTypeArr))
            .then(() => {
                dispatch(showAlertSnackbar({message: accountId, type: 'success'}))
                setLoading(false);
                handleClose();
            })
        })
    }
    function salaryTypeParam() {
        let salaryTypeArr = [];
        driverSalaryState.map((item)=>{
            if (item.label === "FIX" && item.checked === true) {
                salaryTypeArr.push({
                    income_type: salaryTypeFix,
                    client: DEFAULT_CLIENT,
                    performance_bonus: DEFAULT_BONUS
                });   
            } else {
                if (item.checked === true) {
                    salaryTypeArr.push({
                        income_type: item.value,
                        client: DEFAULT_CLIENT,
                        performance_bonus: DEFAULT_BONUS
                    }) ;
                }
            }
        });
        if(salaryTypeArr.length === 0) {
            dispatch(showAlertSnackbar({message: t('missing_salary'), type: 'error'}))
            return false;
        }
        return salaryTypeArr;
    }
    function createParamsAdditional() {
        let params = {} 
        params['role'] = role;
        params['supplies'] = suppliesStr;
        if(!checkedSorting) {
            params['bossflg'] = 0
        } else {
            params['bossflg'] = 1
        }
        params['team_leader'] = 0;
        params['team_id'] = 0;
        params['is_hired'] = 1;
        params['background_check_status'] = backgroundChecked;
        return checkMisssing(params);
    }
    function checkMisssing(params) {
        let missingParam = '';
        for(var key in params) {
            if(params[key] === 0) {
                continue;
            } else if(!params[key] && key !== 'gst_number' && key !== 'team_id') {
                missingParam += ', ' + key;
            }
        }
        if(missingParam) {
            missingParam = missingParam.substring(1);
            dispatch(showAlertSnackbar({message: missingParam + ' ' + t('missing') , type: 'error'}))
            return false;
        }
        return params;
    }
    function handleSaveBasicInfo() {
        let params = {
            first_name: firstName,
            middle_name: middleName,
            last_name: lastName,
            phone: mobile,
            postal_code: zip,
            country: country,
            city: city,
            province: province,
            email: email,
            address: address,
            license_number: licenseNum,
            vehicle_plate: vehiclePlate,
            vehicle_type: vehicleType,
            sin_number: sin,
            emergency_contact_name: emergencyName,
            emergency_contact_number: emergencyNum,
            account_holder_name: accountHolder,
            account_number: accountNum,
            gst_number: gst,
            license_expiry_date: expiryDate,
            warehouse_id: warehouseId
        }
        // US-BRANCH-OFF
        if(userUS) {
            params['bank_name'] = institution;
            params['routing_number'] = transit;
        } else {
            params['institution_number'] = institution;
            params['transit_number'] = transit;
        }
        for (const item in params) {
            if(item !== 'gst_number') {
                if(!params[item]) {
                    dispatch(showAlertSnackbar({message: t('missing') + ' ' + item + ' ' + t('info'), type: 'error'}));
                    return;
                }
            }
        }
        dispatch(editProfile(props.driverOpenInfo.id, params))
        .then((res) => {
            setEnableEdit(false);
            dispatch(showAlertSnackbar({message: t('update_success'), type: 'success'}))
        })
        .catch((err) => {
            setEnableEdit(false);
            dispatch(showAlertSnackbar({message: t('update_fail'), type: 'error'}))
        })
    }
    function handleReview(id, from, to) {
        let params = {
            operator: userPref.username
        };
        if(to === 'approve') {
            params.decision = 8;
            handleApprove();
        } else if(to === 'pending') {
            params.decision = 2;
            params.reason = reason;
        } else if(to === 'redo') {
            if(from === 1) {
                params.decision = 9;
            } else if(from === 9) {
                params.decision = 2;
                params.reason = 'R0';
            }
        }
        dispatch(putReviewResult(id, params))
        .then(() => {
            setStatus(params.decision);
            if(params.decision === 8) {
                setStatusLabel('Approved');
            } else if(params.decision === 9) {
                setStatusLabel('Rejected');
            } else if(params.decision === 2) {
                setStatusLabel('Pending');
            }
            dispatch(showAlertSnackbar({message: t('review_success'), type: 'success'}))
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: t('review_fail'), type: 'error'}))
        })
    }

    useEffect(() => {
        setOpenModal(props.open);
        if(props.open) {
            init();
            if(props.driverOpenInfo) {
                if(props.driverOpenInfo.id) {
                    dispatch(getProfile(props.driverOpenInfo.id))
                    .then((res) => {
                        dispatch(getDeliveryAreas(res.basis.province))
                        dispatch(getCityList(res.basis.province))
                    })
                    dispatch(getIndividualDocument(props.driverOpenInfo.id))
                    .then((res) => {
                        setSlideImages(res)
                    })
                    .catch((err) => {
                        dispatch(showAlertSnackbar({message: t('no_img'), type: 'error'}))
                        setSlideImages([])
                    })
                }
                if(props.driverOpenInfo.account_id) {
                    setDriverId(props.driverOpenInfo.account_id);
                    setStatus(props.driverOpenInfo.status);
                    setStatusLabel(props.driverOpenInfo._label_status);
                    dispatch(getDriverAdditional(props.driverOpenInfo.account_id))
                    .then((res) => {
                        applyData(res);
                        setUsername(res.username);
                        setBackgroundChecked(res.background_check_status);
                        if(res.supplies) {
                            let suppliesArr = JSON.parse(res.supplies);
                            setSupplies(suppliesArr);
                        }
                        setDriverInfo(res);
                    })
                }
            }
        }
    }, [props.open])
    useEffect(() => {
        if(driverProfile) {
            let basis = driverProfile.basis;
            let driver = driverProfile.driver;
            let payout = driverProfile.payout;
            if(basis) {
                setLastName(basis.last_name);
                setMiddleName(basis.middle_name);
                setFirstName(basis.first_name);
                setMobile(basis.phone);
                setEmail(basis.email);
                setAddress(basis.address);
                setZip(basis.postal_code);
                setCity(basis.city);
                setProvince(basis.province);
                setCountry(basis.country);
                setWarehouseId(basis.warehouse_id);
            }
            if(driver) {
                setLicenseNum(driver.license_number);
                setVehiclePlate(driver.vehicle_plate);
                setVehicleType(driver.vehicle_type);
                setSin(driver.sin_number);
                setEmergencyName(driver.emergency_contact_name);
                setEmergencyNum(driver.emergency_contact_number);
                setExpiryDate(driver.license_expiry_date);
            }
            if(payout) {
                setAccountHoler(payout.account_holder_name);
                setAccountNum(payout.account_number);
                setInstitution(payout.institution_number || payout.bank_name);
                setTransit(payout.transit_number);
                setGst(payout.gst_number);
            }
        }
    }, [driverProfile])
    useEffect(() => {
        if(supplies) {
            if(supplies.length > 0) {
                setSuppliesStr(JSON.stringify(supplies))
            }
        }
    }, [supplies])

    return (
        <Dialog
            open={openModal}
            onClose={handleClose}
            maxWidth='lg'
            fullWidth
        >
            <DialogTitle>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={{display: 'flex', alignItems: 'baseline'}}>
                        <span>{t('driver_application')}</span>
                        <span
                            className={classes.titleStatus}
                        >
                            {t('status')} 
                            {
                                status &&
                                <span
                                    style={
                                        status === 1 ?
                                        {
                                            color: '#dd4b3f'
                                        } : (
                                            status === 9 ?
                                            {
                                                color: '#8a8b8a'
                                            } : (
                                                status === 8 ?
                                                {
                                                    color: '#66bb6a'
                                                } : {
                                                    color: '#ffffff'
                                                }
                                            )
                                        )
                                    }
                                >
                                    {statusLabel}
                                </span>
                            }
                        </span>
                    </div>
                    <Tooltip title={t('common:cancel')} aria-label="cancel">
                        <CloseIcon onClick={handleClose}></CloseIcon>
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent dividers  className={classes.content}>
                <div className={classes.info}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div className={classes.infoTitle}>{t('basic_info')}</div>
                        {
                            !enableEdit &&
                            <div 
                                onClick={()=>setEnableEdit(true)}
                                style={{
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    color: '#e4e4e3',
                                    borderBottom: 'solid 1px #e4e4e3',
                                    cursor: 'pointer'
                                }}
                            >
                                {t('edit')}
                            </div>
                        }
                        {
                            enableEdit &&
                            <div style={{display: 'flex'}}>
                                <div 
                                    onClick={()=>{
                                        dispatch(getProfile(props.driverOpenInfo.id));
                                        setEnableEdit(false);
                                    }}
                                    style={{
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        color: '#e4e4e3',
                                        borderBottom: 'solid 1px #e4e4e3',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {t('cancel')}
                                </div>
                                <div 
                                    style={{
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        color: '#ff9d00',
                                        borderBottom: 'solid 1px #ff9d00',
                                        marginLeft: 20,
                                        cursor: 'pointer'
                                    }}
                                    onClick={handleSaveBasicInfo}
                                >{t('save')}</div>
                            </div>
                        }
                    </div>
                    <div className={classes.infoContent}>
                        <Grid container spacing={3}>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('last_name')}
                                    </InputLabel>
                                    <OutlinedInput 
                                        disabled={!enableEdit}
                                        value={lastName}
                                        onChange={(e) => {
                                            setLastName(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('first_name')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled={!enableEdit}
                                        value={firstName}
                                        onChange={(e) => {
                                            setFirstName(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('middle_name')}
                                    </InputLabel>
                                    <OutlinedInput
                                        id='editdriver-driverapproval-middlename-input'
                                        disabled={!enableEdit}
                                        value={middleName}
                                        onChange={(e) => {
                                            setMiddleName(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('phone')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled
                                        value={mobile}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('email')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled={!enableEdit}
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('address')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled={!enableEdit}
                                        value={address}
                                        onChange={(e) => {
                                            setAddress(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('ZIP')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled={!enableEdit}
                                        value={zip}
                                        onChange={(e) => {
                                            setZip(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                    {t('city')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled={!enableEdit}
                                        value={city}
                                        onChange={(e) => {
                                            setCity(e.target.value);
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} container>
                                <Grid item xs={6} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                        {t('license_no')}
                                        </InputLabel>
                                        <OutlinedInput
                                            disabled={!enableEdit}
                                            value={licenseNum}
                                            onChange={(e) => {
                                                setLicenseNum(e.target.value)
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{marginTop: 10}}></Grid>
                                <Grid item xs={5} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                            {t('license_expiry_date')}
                                        </InputLabel>
                                        <OutlinedInput
                                            type="date"
                                            disabled={!enableEdit}
                                            value={expiryDate}
                                            onChange={(e) => {
                                                setExpiryDate(e.target.value)
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                            {t('vehicle_plate')}
                                        </InputLabel>
                                        <OutlinedInput
                                            disabled={!enableEdit}
                                            value={vehiclePlate}
                                            onChange={(e) => {
                                                setVehiclePlate(e.target.value)
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1} style={{marginTop: 10}}></Grid>
                                <Grid item xs={5} style={{marginTop: 10}}>
                                    {
                                        vehicleList &&
                                        vehicleList.length > 0 &&
                                        driverProfile &&
                                        driverProfile.driver &&
                                        <FormControl fullWidth variant="outlined">
                                            <InputLabel style={{
                                                    backgroundColor: '#424242',
                                                    paddingLeft: 10,
                                                    paddingRight: 10
                                                }}
                                                shrink={true}
                                            >
                                                {t('vehicle_type')}
                                            </InputLabel>
                                            <Select
                                                disabled={!enableEdit}
                                                value={vehicleType || driverProfile.driver.vehicle_type}
                                                onChange={(e) => {
                                                    setVehicleType(e.target.value)
                                                }}
                                            >
                                                {
                                                    vehicleList.map((type) => (
                                                        <MenuItem value={type.code}>
                                                            {type.name}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    }
                                </Grid>
                                <Grid item xs={6} style={{marginTop: 10}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel
                                            style={{
                                                backgroundColor: '#424242',
                                                paddingLeft: 10,
                                                paddingRight: 10
                                            }}
                                            shrink={true}
                                        >
                                        {
                                            t('SSN_SIN')
                                        }
                                        </InputLabel>
                                        <OutlinedInput
                                            disabled={!enableEdit}
                                            value={sin}
                                            onChange={(e) => {
                                                setSin(e.target.value)
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel 
                                        className={classes.labelStyle}
                                        shrink={true}
                                    >
                                        {t('bank_info')}
                                    </InputLabel>
                                    <OutlinedInputTop
                                        startAdornment={<InputAdornment position="start">{t('account_holder')}</InputAdornment>}
                                        labelWidth={60}
                                        disabled={!enableEdit}
                                        value={accountHolder}
                                        onChange={(e) => {
                                            setAccountHoler(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBetween
                                        startAdornment={<InputAdornment position="start">{t('account_number')}</InputAdornment>}
                                        labelWidth={60}
                                        disabled={!enableEdit}
                                        value={accountNum}
                                        onChange={(e) => {
                                            setAccountNum(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBetween
                                        startAdornment={<InputAdornment position="start">{t('bank_name_institution_number')}</InputAdornment>}
                                        labelWidth={60}
                                        disabled={!enableEdit}
                                        value={institution}
                                        onChange={(e) => {
                                            setInstitution(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBetween
                                        startAdornment={<InputAdornment position="start">{t('routing_number_transit_number')}</InputAdornment>}
                                        labelWidth={60}
                                        disabled={!enableEdit}
                                        value={transit}
                                        onChange={(e) => {
                                            setTransit(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBottom
                                        startAdornment={<InputAdornment position="start">{t('TAX_GST')}</InputAdornment>}
                                        labelWidth={60}
                                        disabled={!enableEdit}
                                        value={gst}
                                        onChange={(e) => {
                                            setGst(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel 
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                        {t('emergency_contact')}
                                    </InputLabel>
                                    <OutlinedInputTop
                                        startAdornment={<InputAdornment position="start">{t('contract_name')}</InputAdornment>}
                                        labelWidth={60}
                                        disabled={!enableEdit}
                                        value={emergencyName}
                                        onChange={(e) => {
                                            setEmergencyName(e.target.value)
                                        }}
                                    />
                                    <OutlinedInputBottom
                                        startAdornment={<InputAdornment position="start">{t('contract_number')}</InputAdornment>}
                                        labelWidth={60}
                                        disabled={!enableEdit}
                                        value={emergencyNum}
                                        onChange={(e) => {
                                            setEmergencyNum(e.target.value)
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item container xs={6}>
                                <Grid item container xs={2}></Grid>
                                <Grid 
                                    item container 
                                    xs={7}
                                    style={{
                                        marginTop: 60
                                    }}
                                >
                                        photocopies of ID card, vehicle insurance and training certificate
                                </Grid>
                                <Grid 
                                    item 
                                    container xs={3}
                                    style={{
                                        position: 'relative',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setPhotoListOpen(true);
                                    }}
                                >
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 12,
                                            right: 0
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 16,
                                            right: 4
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 20,
                                            right: 8
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 24,
                                            right: 12,
                                            backgroundImage: "url('./images/idSample.jpeg')",
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    ></div>
                                    <div
                                        className={classes.photoGroup}
                                        style={{
                                            top: 24,
                                            right: 12,
                                            backgroundColor: 'rgba(0,0,0,0.6)'
                                        }}
                                    ></div>
                                    {
                                        slideImages &&
                                        slideImages.length > 0 &&
                                        <div
                                            style={{
                                                position: 'absolute',
                                                right: 60,
                                                top: 42,
                                                fontSize: 48,
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                color: '#fff'
                                            }}
                                        >
                                            {slideImages.length}
                                        </div>
                                    }
                                    {
                                        (!slideImages ||
                                        slideImages.length === 0) &&
                                        <div
                                            style={{
                                                position: 'absolute',
                                                right: 60,
                                                top: 42,
                                                fontSize: 48,
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                color: '#fff'
                                            }}
                                        >
                                            0
                                        </div>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div className={classes.info}>
                    <div className={classes.infoTitle}>
                        {t('additional_info')}
                    </div>
                    <div className={classes.infoContent}>
                        <Grid container spacing={3}>
                            <Grid item xs={2}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                        {t('ID')}
                                    </InputLabel>
                                    <OutlinedInput
                                        disabled
                                        value={driverId}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                        style={{
                                            backgroundColor: '#424242',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }}
                                        shrink={true}
                                    >
                                        {t('username')}
                                    </InputLabel>
                                    <OutlinedInput
                                        value={username}
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField 
                                    fullWidth
                                    select
                                    variant="outlined"
                                    label={t('driver_type')}
                                    value={role} 
                                    onChange={(e)=>{setRole(parseInt(e.target.value))}}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    {driverTypeList.map((item) => (
                                        <option key={item.label} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                                    <div style={{textAlign: 'center'}}>{t('sorting_scan')}</div>
                                    <div
                                        className={classes.switch}    
                                    >
                                        <div>{t('off')}</div>
                                        <AntSwitch 
                                            checked={checkedSorting}
                                            onChange={handleSortingChange}
                                        />
                                        <div>{t('on')}</div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        {
                            // US-BRANCH-OFF
                            userUS &&
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <div 
                                        style={{
                                            display: 'flex', 
                                            alignItems: 'center',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <Checkbox 
                                            color='secondary'
                                            checked={backgroundChecked}
                                            onChange={(e)=>{
                                                if(e.target.checked) {
                                                    setBackgroundChecked(1);
                                                } else {
                                                    setBackgroundChecked(0);
                                                }
                                            }}
                                        />
                                        <div>{t('background_checked')}</div>
                                    </div>
                                </Grid>
                            </Grid>
                        }
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <div className={classes.supplies}>
                                    {
                                        supplies.map((supply, index) => (
                                        <div className={classes.supply}>
                                            <div className={classes.supplyMinusAdd}>
                                                <RemoveIcon 
                                                    style={{
                                                        width: 36,
                                                        height: 36,
                                                        color: "#ff9d00"
                                                    }}
                                                    onClick={()=>handleSupply(index,supply, -1)}
                                                />
                                            </div>
                                            <div style={{fontSize: 16,fontWeight: 'bold',  textAlign: 'center', color: '#262626'}}>
                                                {supply.item}: {supply.count}
                                            </div>
                                            <div className={classes.supplyMinusAdd}>
                                                <AddIcon 
                                                    style={{
                                                        width: 36,
                                                        height: 36,
                                                        color: "#ff9d00"
                                                    }}
                                                    onClick={()=>handleSupply(index, supply, 1)}
                                                />
                                            </div>
                                        </div>
                                        ))
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={12} container>
                                <Grid item xs={12} className={classes.addtionalTitle}>{t('salary_type')}</Grid>
                                <Grid item xs={12} container style={{display: 'flex'}}>
                                {
                                    driverSalaryState &&
                                    driverSalaryState.length > 0 &&
                                    driverSalaryState.map((item,index)=>{
                                    if (item.label==="FIX" && item.checked === true) {
                                        return (
                                            <MenuItem key={item.label + index} style={{paddingLeft: 0}}>
                                                <MenuItem key={item.label + index} style={{paddingLeft: 0}}>
                                                    <Checkbox 
                                                        key={index} 
                                                        checked={item.checked}
                                                        onClick={(e)=>{setDriverSalaryState(driverSalaryState.map((ele,idx)=>idx===index? 
                                                            {...ele, checked: e.target.checked}:
                                                            ele)
                                                        )}}
                                                    ></Checkbox>
                                                    <span>{item.label}</span>
                                                </MenuItem>
                                                <TextField
                                                    id="salaryTypeFix"
                                                    select
                                                    label={t('please_select')}
                                                    InputLabelProps={{ shrink: true }}
                                                    variant="outlined"
                                                    value={salaryTypeFix} 
                                                    onChange={(e)=>{setSalaryTypeFix(e.target.value)}}
                                                    SelectProps={{
                                                        native: true,
                                                    }}      
                                                    style={{width: 250}}
                                                >
                                                {
                                                    driverSalaryTypeFixList &&
                                                    driverSalaryTypeFixList.length > 0 &&
                                                    driverSalaryTypeFixList.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))      
                                                }
                                                </TextField>
                                            </MenuItem>
                                        )    
                                    } else {
                                        return (
                                            <MenuItem key={item.label + index} style={{paddingLeft: 0}}>
                                                <Checkbox 
                                                    key={index} 
                                                    checked={item.checked}
                                                    onClick={(e)=>{setDriverSalaryState(driverSalaryState.map((ele,idx)=>idx===index? 
                                                        {...ele, checked: e.target.checked}:
                                                        ele)
                                                    )}}
                                                ></Checkbox>
                                                <span>{item.label}</span>
                                            </MenuItem>           
                                        )    
                                    }
                                })
                            }
                            </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div className={classes.buttonGroup}>
                    <ColorButton
                        disabled={status !== 1 && status !== 9}
                        onClick={() => handleReview(props.driverOpenInfo.id, status, 'redo')}
                    >
                        {
                            status === 9 ?
                            t('reopen') : t('reject')
                        }
                    </ColorButton>
                    <div style={{display: 'flex'}}>
                        <FormControl 
                            variant="outlined" 
                            className={classes.formControl}
                        >
                            <InputLabel 
                                style={{
                                    backgroundColor: '#424242',
                                    paddingLeft: 10,
                                    paddingRight: 10
                                }}
                            >
                                {t('reason_for_pending')}
                            </InputLabel>
                            <ColorSelect 
                                variant="outlined"
                                MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                                value={reason}
                                onChange={(e)=>setReason(e.target.value)}
                            >
                                {
                                    pendingReasonList.map((reason, index) => (
                                    <MenuItem 
                                        className={classes.menuItem} 
                                        value={reason.id}
                                        style={
                                            index === 0 ? {
                                                borderTop: 'none'
                                            } : {}
                                        }
                                    >
                                        {reason.name}
                                    </MenuItem>
                                    ))
                                }
                            </ColorSelect>
                        </FormControl>
                        <Button
                            variant="contained"
                            color='primary'
                            disabled={
                                status !== 1 || !reason
                            }
                            onClick={() => handleReview(props.driverOpenInfo.id, status, 'pending')}
                        >
                            {t('_pending')}
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{
                                marginLeft: 100,
                            }}
                            onClick={() => handleReview(props.driverOpenInfo.id, status, 'approve')}
                            disabled={status !== 1}
                        >
                            {t('approve')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
            <SlideShow open={photoListOpen} handleClose={handlePhotoListClose} slideImages={slideImages} type='approval'/>
        </Dialog>
    )
}
export default DriverRegistration;